<template >
  <div class="nutrients">
    <Head :title="$ml.get(`Nutrients`)" />
    <div>
      <div class="nut-w" v-for="(item, i) in nutrients">
        <div class="title">
          {{item.label}}
        </div>
        <!-- <dropList>
            <template v-slot:header>
              {{item.label}}
            </template>
            <template> -->
            <NutrientElement :info="info" :key="i" :nutTable="nutTable" :item="item" />
            <!-- </template>
          </dropList> -->
      </div>
    </div>
  </div>
</template>

<script>
import Head from './helps/Head.vue';
import DropList from "@/components/common/DropList";
import NutLine from "./nut-line";
import NutrientElement from './NutrientElement'
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  data () {
    return {
      nutrients: [],
      key: 0,
      unit: 'ppm'
    }
  },
  props: {
    nutTable: Object,
    info: Object
  },
  mixins: [  UnitConverter  ],

  components: {
    Head,
    NutrientElement,
    DropList,
    NutLine,

  },
  created () {
    this.nutrients = this.$store.getters['labs/popup/nutrients'];
  },
  methods: {
    onInput(value) {

      // converting view
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(this.item.type, this.unit, value);
      }
      this.item.value = this.toPpm(this.item.type, this.unit, value);

      if(this.item.n_form) {
        this.$store.commit('tests/soil/computeN');
      }
    },

    convertLow(val) {

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.type, this.unit, this.item.value);
      }

      val = this.toUnit(this.item.type, this.unit, val);
      return val ? val.toFixedGentle(2) : null;
      // return val;
    },
    convertHigh(val) {

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.type, this.unit, this.item.value);
      }

      val = this.toUnit(this.item.type, this.unit, val);
      return val ? val.toFixedGentle(2) : null;
      // return val;
    },
    convertAd(val) {

      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.type, this.unit, this.item.value);
      }

      val = this.toUnit(this.item.type, this.unit, val);
      return val ? val.toFixedGentle(2) : null;
      // return val;
    },
    createNut (nut) {
      if (this.info.id) {
        this.$store.dispatch('labs/popup/createNut', nut).then(res => {
          this.$notify({
            group: 'notices',
            title: `Ext successfully added!`,
            type : 'Success',
          });

          this.key++;
        }).catch(err => {
          this.$notify({
            group: 'notices',
            title: err,
            type : 'error',
          });
        });
      } else {
        this.$notify({
          group: 'notices',
          title: `Please save info!`,
          type : 'error',
        });
      }
    }
  },
  computed:{

  }
}
</script>

<style lang="scss">
.nutrients {
  width: 100%;

  .nut-w {
    margin-top: 17px;
  }

}

.input-label.default.active {
    display: ruby;
  }
</style>
